export default __webpack_public_path__ + "b981d18c7ca054c83fb94bf6300d9f56.svg";